import script from "./TopContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TopContent.vue?vue&type=script&setup=true&lang=js"

import "./TopContent.vue?vue&type=style&index=0&id=bfdd98c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfdd98c4"]])

export default __exports__